import { render, staticRenderFns } from "./wordselect.vue?vue&type=template&id=0bf986e7&"
import script from "./wordselect.vue?vue&type=script&lang=js&"
export * from "./wordselect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports